import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';

const Profile = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (auth.currentUser) {
        try {
          let docRef = doc(db, "users", auth.currentUser.uid);
          let docSnap = await getDoc(docRef);
          
          if (!docSnap.exists()) {
            docRef = doc(db, "kullanicilar", auth.currentUser.uid);
            docSnap = await getDoc(docRef);
          }
          
          if (docSnap.exists()) {
            setUserData(docSnap.data());
          }
        } catch (error) {
          console.error("Profil çekme hatası:", error);
        }
      }
    };
    fetchProfile();
  }, []);

  return (
    // SCROLL KİLİDİ AÇILDI
    <div className="fixed inset-0 w-full h-full overflow-y-auto bg-slate-50 z-50 pb-20">
      <div className="max-w-4xl mx-auto py-10 px-6 min-h-full">
        
        <div className="flex justify-between items-center mb-10 bg-white p-6 rounded-3xl shadow-sm border border-slate-100">
          <div>
            <h1 className="text-2xl font-black text-slate-900 uppercase italic tracking-tighter">Profilim</h1>
            <p className="text-slate-400 text-xs font-bold uppercase tracking-widest">Kullanıcı Bilgileriniz</p>
          </div>
          <Link to="/" className="bg-slate-800 text-white px-6 py-3 rounded-xl font-bold text-sm shadow-lg active:scale-95 transition-all">
            Haritaya Dön
          </Link>
        </div>

        <div className="bg-white p-8 rounded-[32px] shadow-sm border border-slate-100">
          {userData ? (
            <div className="space-y-6">
              <div className="border-b border-slate-100 pb-4">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Ad Soyad</p>
                <p className="text-xl font-black text-slate-800 capitalize">
                    {userData.firstName} {userData.lastName} {userData.adSoyad}
                </p>
              </div>
              <div className="border-b border-slate-100 pb-4">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Kayıtlı E-Posta</p>
                <p className="text-lg font-bold text-slate-600">
                    {userData.email || auth.currentUser.email || 'Telefon İle Giriş Yapıldı'}
                </p>
              </div>
              <div className="pb-2">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Kayıtlı Telefon</p>
                <p className="text-lg font-bold text-slate-600">
                    {userData.phone || userData.telefon || 'Belirtilmemiş'}
                </p>
              </div>
            </div>
          ) : (
            <div className="text-center p-10 text-slate-400 font-bold uppercase">Bilgiler Yükleniyor...</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;